var _rect, _rect2, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModify(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 6,
    fill: "#F96C75",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 5.5,
    stroke: "#F96C75",
    strokeOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10C14.49 10 10 14.49 10 20C10 25.51 14.49 30 20 30C25.51 30 30 25.51 30 20C30 14.49 25.51 10 20 10Z",
    fill: "#F96C75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.36 23.36C23.65 23.07 23.65 22.59 23.36 22.3L21.06 20L23.36 17.7C23.65 17.41 23.65 16.93 23.36 16.64C23.07 16.35 22.59 16.35 22.3 16.64L20 18.94L17.7 16.64C17.41 16.35 16.93 16.35 16.64 16.64C16.35 16.93 16.35 17.41 16.64 17.7L18.94 20L16.64 22.3C16.35 22.59 16.35 23.07 16.64 23.36C16.79 23.51 16.98 23.58 17.17 23.58C17.36 23.58 17.55 23.51 17.7 23.36L20 21.06L22.3 23.36C22.45 23.51 22.64 23.58 22.83 23.58C23.02 23.58 23.21 23.51 23.36 23.36Z",
    fill: "#20243B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModify);
export default __webpack_public_path__ + "static/media/modify.23a45849f6c07941e65a6d50f27f9358.svg";
export { ForwardRef as ReactComponent };